"use client";

import { Card } from "@/components/ui-system";

import { useDeviceAuditLog } from "@/modules/devices/hooks";

export type DeviceDebugAuditProps = {
  deviceId: string;
};

function summarize(obj: Record<string, unknown>): string {
  const keys = Object.keys(obj);
  if (keys.length === 0) return "-";
  return keys.slice(0, 6).join(", ") + (keys.length > 6 ? "..." : "");
}

export function DeviceDebugAudit({ deviceId }: DeviceDebugAuditProps) {
  const entries = useDeviceAuditLog(deviceId);

  return (
    <Card className="border-border/60 p-0 shadow-card">
      <div className="max-h-96 overflow-auto">
        {entries.length === 0 ? (
          <p className="p-ds-5 text-caption text-muted">
            No activity recorded yet. Updates, OTA, and channel changes appear here during this session.
          </p>
        ) : (
          <ul className="divide-y divide-border/40">
            {entries.map((e) => (
              <li key={e.id} className="px-ds-5 py-ds-3 text-caption">
                <div className="flex flex-wrap items-baseline justify-between gap-ds-2">
                  <span className="text-micro uppercase tracking-wide text-muted">
                    {new Date(e.timestamp).toLocaleString()}
                  </span>
                  <span className="text-micro text-primary">{e.action}</span>
                </div>
                <p className="mt-ds-1 break-all text-muted">
                  {e.user_id ? <span className="text-foreground">@{e.user_id}</span> : <span>Local</span>}
                  <span className="mx-ds-2 text-border">-</span>
                  <span className="text-micro">{summarize(e.payload_summary)}</span>
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
}
